import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'

export default {
  name: 'cargo-shipment-bag-summary',
  components: {
    Paginate,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      transcationDetailsForMPSTable:false,
      transcationDetailsForMPS:[],
      auditLog:[],
      showModalBag:false,
      bagShipmentDetails:[],
      showbagShipmentDetailsModal:false,
      bagDetails:[],
      parentAwbDetails:[],
      paperWorkUFDetails:[],
      showPaperWorkUFModal:false,
      showShipmentDetailsTable:false,
      showBagdetailsTable:false,
      bagNo:'',
      showAWBTrack:false,
      AWBtrackData:[],
      showShipmentTrack:false,
      shipmentTrackData:[],
      paperbagdetails:[],
      showPaperBagTable:false,
      showShipmentTranscationTable:false,
      transcationDetails:[],
      isLoadingSearch: false,
      parentMPS: '',
      ParentMPSError: false,
      ParentMPSErrorMSG: '',
      ParentMPSDetails: [],
      parentAWB: '',
      showParentMPSDetailsTable: true,
      ParentAWBError: false,
      ParentAWBErrorMSG: '',
      hubId: '',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      chargeableWeight:0,
      physicalWeight:0,
      hublist: [],
      showPalletizationLogModal: false,
      palletizationLogRows: [],
      // 'MPS' = container allocation (MPS level), 'PAPERWORK' = paperwork allocation (parent AWB level)
      palletizationLogType: 'MPS'
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    BagCategory: function(isparentbag){
      if (isparentbag==true) {
        return "Parent";
      }else if(isparentbag==false){
        return "Child";
      }
    }
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubId = userdetail[0].HubId[0];
    this.getHubList();
  },
  methods: {
    getHubList() {
      this.hublist = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closePalletizationLogModal() {
      this.showPalletizationLogModal = false;
      this.palletizationLogRows = [];
      this.palletizationLogType = 'MPS';
    },
    // Hub name from API; falls back to page hub list when bin/pallet master has no hubname
    getPalletizedLocation(row) {
      if (row.hubName) {
        return row.hubName;
      }
      const hub = this.hublist.find(h => String(h.value) === String(row.hubId));
      return hub ? hub.text : (row.hubId || '--');
    },
    // lookupType: 'MPS' (one MPS), 'PARENT_AWB' (all MPS of a parent), 'PAPERWORK' (parent AWB paperwork)
    showPalletizationLog(shippingId, lookupType) {
      if (!shippingId) {
        return;
      }
      const type = lookupType || 'MPS';
      this.palletizationLogType = type === 'PAPERWORK' ? 'PAPERWORK' : 'MPS';
      this.isLoadingSearch = true;
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'getShipmentPalletizationHistory?shippingId=' + encodeURIComponent(shippingId.trim()) + '&lookupType=' + type,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': 'WEB',
          'token': this.token
        }
      })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode === 100) {
            this.palletizationLogRows = result.data.ResponseData || [];
            // Backend falls back from MPS to paperwork when no MPS row exists, so trust row source
            if (this.palletizationLogRows.length && this.palletizationLogRows[0].source) {
              this.palletizationLogType = this.palletizationLogRows[0].source === 'PAPERWORK' ? 'PAPERWORK' : 'MPS';
            }
            this.showPalletizationLogModal = true;
          } else if (result.data.ResultCode === 101) {
            this.palletizationLogRows = [];
            this.showPalletizationLogModal = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage || 'Palletization history not found');
          }
        }, error => {
          this.isLoadingSearch = false;
          console.error(error);
        });
    },
    showShipmentTranscationDetails(){
      this.showShipmentTranscationTable=true;
    },
    showPaperWorkDetailsFromUF(parentawb) {
      if (!parentawb) {
        return;
      }
      this.isLoadingSearch = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getPaperWorkDetailsFromUF',
          data: {
            parentawb: String(parentawb).trim()
          },
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'Content-Type': 'application/json',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          const parsed = this.parsePaperWorkUFResponse(result.data);
          if (parsed.resultCode == 100) {
            this.paperWorkUFDetails = this.mapPaperWorkUFDetails(parsed.paperWorkDetails);
            this.invalidTokenModal = false;
            this.$nextTick(() => {
              this.showPaperWorkUFModal = true;
            });
            if (parsed.returnMessage) {
              this.$alertify.success(parsed.returnMessage);
            }
          } else if (parsed.resultCode == 401) {
            this.invalidTokenModal = true;
            this.invalidtokenmsg = parsed.returnMessage;
            this.$alertify.error(parsed.returnMessage);
          } else {
            this.invalidTokenModal = false;
            this.paperWorkUFDetails = [];
            this.$alertify.error(parsed.returnMessage || 'Unable to fetch paper work details');
          }
        }, error => {
          this.isLoadingSearch = false;
          console.error(error);
          this.$alertify.error("API Error");
        });
    },
    parsePaperWorkUFResponse(responseData) {
      const data = responseData || {};
      const ufResponse = data.UFResponse;
      let payload = data;
      let paperWorkDetails = [];

      if (ufResponse && typeof ufResponse === 'object') {
        payload = Object.assign({}, data, ufResponse);
        if (Array.isArray(ufResponse.Result)) {
          paperWorkDetails = ufResponse.Result;
        }
      } else if (data.ResponseData != null && typeof data.ResponseData === 'object' && !Array.isArray(data.ResponseData)) {
        payload = Object.assign({}, data, data.ResponseData);
      }

      const resultCode = data.ResultCode != null ? data.ResultCode
        : (ufResponse && ufResponse.ReturnCode != null ? ufResponse.ReturnCode
        : (payload.ReturnCode != null ? payload.ReturnCode : payload.ResultCode));

      if (paperWorkDetails.length === 0) {
        if (Array.isArray(payload.Result)) {
          paperWorkDetails = payload.Result;
        } else if (Array.isArray(data.Result)) {
          paperWorkDetails = data.Result;
        } else if (Array.isArray(payload.ResponseData)) {
          paperWorkDetails = payload.ResponseData;
        } else if (Array.isArray(data.ResponseData)) {
          paperWorkDetails = data.ResponseData;
        }
      }

      return {
        resultCode: resultCode,
        paperWorkDetails: paperWorkDetails,
        returnMessage: (ufResponse && ufResponse.ReturnMessage) || data.ReturnMessage || payload.ReturnMessage
      };
    },
    mapPaperWorkUFDetails(paperWorkDetails) {
      const hubDetails = {};
      (this.hublist || []).forEach(function(hub) {
        hubDetails[hub.value] = hub.text;
      });
      return (paperWorkDetails || []).map(function(item) {
        const row = Object.assign({}, item);
        row.paperworkcurrenthubName = '';
        if (row.paperworkcurrenthubid && hubDetails[row.paperworkcurrenthubid]) {
          row.paperworkcurrenthubName = hubDetails[row.paperworkcurrenthubid];
        }
        return row;
      });
    },
    closePaperWorkUFModal() {
      this.showPaperWorkUFModal = false;
      this.paperWorkUFDetails = [];
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    showShipmentTranscationDetailsForMPSTrack(ShippingId){
      if (!ShippingId) {
        return;
      }
      this.isLoadingSearch = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getCargoShipmentDetails?ShippingID=' + ShippingId,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            var transcationDetailsForMPS =result.data.ResponseData[0].Transactions
            var hubDetails = [];
            var logData = [];
            for (var i = 0; i < this.hublist.length; i++) {
              hubDetails[this.hublist[i].value] = this.hublist[i].text;
            }
            if (transcationDetailsForMPS.length > 0) {
              transcationDetailsForMPS.forEach(function(item) {
                item["ProcessLocationName"] = '';
                if (item.ProcessLocation && hubDetails[item.ProcessLocation]) {
                  item["ProcessLocationName"] = hubDetails[item.ProcessLocation];
                }
                item["CurrentLocationName"] = '';
                if (item.CurrentLocation && hubDetails[item.CurrentLocation]) {
                  item["CurrentLocationName"] = hubDetails[item.CurrentLocation];
                }
                logData.push(item);
              });
            }
            this.transcationDetailsForMPS = logData;
            this.invalidTokenModal = false
            this.transcationDetailsForMPSTable=true;
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.showParentMPSDetailsTable = true;
            this.ParentMPSDetails = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })
    },
    closeModal() {
      this.transcationDetailsForMPSTable=false;
      this.showShipmentTranscationTable = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    closeBagModal() {
      this.showModalBag = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    getParentMPSDetails() {
      if (this.parentMPS == '' || this.parentMPS == undefined) {
        this.ParentMPSError = true;
        this.ParentMPSErrorMSG = 'Enter Shipping ID';
        return false;
      }
      this.ParentMPSError = false;
      this.ParentMPSError = '';
      this.isLoadingSearch = true;
      var parentMPS= this.parentMPS.toUpperCase();
      let MPAstart =new RegExp("^MPA");
      let MPSstart =new RegExp("^MPS");
      let Sstart =new RegExp("^S");
      let Astart =new RegExp("^A");
      let BNstart =new RegExp("^BN");
      let BDstart =new RegExp("^BD");
      let rBNstart =new RegExp("^R_BN");
      let rBDstart =new RegExp("^R_BD");
      let newRegex = /^(U_)?(R_)?(D(0?[0-9]|[1-4][0-9]|50)_)?(MPA|MPS|A|S)\d+$/;

      this.ParentMPSDetails = [];
      this.showBagdetailsTable=false;
      this.showAWBTrack=false;
      this.showPaperBagTable=false;
      this.showShipmentTrack=false;
      this.paperbagdetails=[];
      this.shipmentTrackData = [];
      this.AWBtrackData=[];

      if(MPAstart.test(parentMPS) == true || MPSstart.test(parentMPS) == true || Astart.test(parentMPS) == true || Sstart.test(parentMPS) == true
      || BNstart.test(parentMPS) == true || BDstart.test(parentMPS) == true || rBNstart.test(parentMPS) == true || rBDstart.test(parentMPS) == true || newRegex.test(parentMPS) == true)
      {
        this.isLoadingSearch = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getCargoShipmentDetails?ShippingID=' + this.parentMPS.trim(),
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.showBagdetailsTable=false;
            this.showAWBTrack=false;
            this.showPaperBagTable=false;
            this.showShipmentTrack=false;
            this.invalidTokenModal = false;
            this.showParentMPSDetailsTable = true;
            //this.showParentAWBdetailsTable = false;
            var transcationDetails =result.data.ResponseData[0].Transactions
            var ParentMPSDetails = result.data.ResponseData;
            var hubDetails = [];
            var MPSData = [];
            var logData = [];
            for (var i = 0; i < this.hublist.length; i++) {
              hubDetails[this.hublist[i].value] = this.hublist[i].text;
            }
            if (ParentMPSDetails.length > 0) {
              ParentMPSDetails.forEach(function(item) {
                item["OriginHubName"] = '';
                if (item.OriginHubID && hubDetails[item.OriginHubID]) {
                  item["OriginHubName"] = hubDetails[item.OriginHubID];
                }
                item["CurrentHubName"] = '';
                if (item.CurrentHubID && hubDetails[item.CurrentHubID]) {
                  item["CurrentHubName"] = hubDetails[item.CurrentHubID];
                }
                item["FinalDestinationName"] = '';
                if (item.FinalDestinationID && hubDetails[item.FinalDestinationID]) {
                  item["FinalDestinationName"] = hubDetails[item.FinalDestinationID];
                }
                if (item.binnumber === null || item.binnumber === undefined) {
                  item.binnumber = item.containernumber || "";
                }
                MPSData.push(item);
              });
            }
            this.ParentMPSDetails = MPSData;

            if (transcationDetails.length > 0) {
              transcationDetails.forEach(function(item) {
                item["ProcessLocationName"] = '';
                if (item.ProcessLocation && hubDetails[item.ProcessLocation]) {
                  item["ProcessLocationName"] = hubDetails[item.ProcessLocation];
                }
                item["CurrentLocationName"] = '';
                if (item.CurrentLocation && hubDetails[item.CurrentLocation]) {
                  item["CurrentLocationName"] = hubDetails[item.CurrentLocation];
                }
                logData.push(item);
              });
            }
            this.transcationDetails = logData;
            this.$alertify.success(result.data.ReturnMessage)

          } else{
            this.showBagdetailsTable=false;
            this.showAWBTrack=false;
            this.showPaperBagTable=false;
            this.showShipmentTrack=false;
            this.invalidTokenModal = false
            this.showParentMPSDetailsTable = false;
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
      }
      else {

        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'getPaperBagSummary?ParentAWB=' + this.parentMPS.trim() + '&ProcessLocation=' +this.hubId,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {

            if (result.data.ResultCode == 100) {
              this.showBagdetailsTable=false;

              this.invalidTokenModal = false
              var paperbagdetails=result.data.ResponseData;
              var hubDetails = [];
              var paperbagData = [];
              for (var i = 0; i < this.hublist.length; i++) {
                hubDetails[this.hublist[i].value] = this.hublist[i].text;
              }
              if (paperbagdetails.length > 0) {
                paperbagdetails.forEach(function(item) {
                  item["originhubName"] = '';
                  if (item.originhubid && hubDetails[item.originhubid]) {
                    item["originhubName"] = hubDetails[item.originhubid];
                  }
                  item["finaldestinationName"] = '';
                  if (item.finaldestinationid && hubDetails[item.finaldestinationid]) {
                    item["finaldestinationName"] = hubDetails[item.finaldestinationid];
                  }
                  paperbagData.push(item);
                });
              }
              this.paperbagdetails = paperbagData;
              this.showPaperBagTable=true;
              this.showParentMPSDetailsTable = false;
            //  this.showParentAWBdetailsTable = false;
            } else{
              this.invalidTokenModal = false
            }
          }, error => {
            console.error(error)
          })

          axios({
              method: 'GET',
              url: apiUrl.api_url_hubops + 'getCargoShipmentDetails?ShippingID=' + this.parentMPS.trim(),
              headers: {
                'authorization': 'authkey xB84JJ89Hd25',
                'requestfrom': "WEB",
                'token': this.token
              }
            })
            .then(result => {
              this.isLoadingSearch = false;
              if (result.data.ResultCode == 100) {
                this.showParentMPSDetailsTable = false;
                this.invalidTokenModal = false
                this.showBagdetailsTable=false;
                var shipmentTrackData=result.data.ResponseData;
                var hubDetails = [];
                var shipmentData = [];
                for (var i = 0; i < this.hublist.length; i++) {
                  hubDetails[this.hublist[i].value] = this.hublist[i].text;
                }
                if (shipmentTrackData.length > 0) {
                  var pWeight = 0
                  var cWeight = 0;
                  shipmentTrackData.forEach(function(item) {
                    pWeight += Number(item.physicalweight)
                    cWeight += Number(item.chargeableweight);
                    item["originhubName"] = '';
                    if (item.originhubid && hubDetails[item.originhubid]) {
                      item["originhubName"] = hubDetails[item.originhubid];
                    }
                    item["currenthubName"] = '';
                    if (item.currenthubid && hubDetails[item.currenthubid]) {
                      item["currenthubName"] = hubDetails[item.currenthubid];
                    }
                    item["finaldestinationName"] = '';
                    if (item.finaldestinationid && hubDetails[item.finaldestinationid]) {
                      item["finaldestinationName"] = hubDetails[item.finaldestinationid];
                    }
                    if (item.binnumber === null || item.binnumber === undefined) {
                      item.binnumber = item.containernumber || "";
                    }
                    shipmentData.push(item);
                  });
                }
                this.chargeableWeight = cWeight;
                this.physicalWeight = pWeight
                this.shipmentTrackData = shipmentData;
                this.AWBtrackData=result.data.ResponseData[0]
                if (this.AWBtrackData) {
                  this.AWBtrackData.originhubName = '';
                  if (this.AWBtrackData.originhubid && hubDetails[this.AWBtrackData.originhubid]) {
                    this.AWBtrackData.originhubName = hubDetails[this.AWBtrackData.originhubid];
                  }
                  this.AWBtrackData.currenthubName = '';
                  if (this.AWBtrackData.currenthubid && hubDetails[this.AWBtrackData.currenthubid]) {
                    this.AWBtrackData.currenthubName = hubDetails[this.AWBtrackData.currenthubid];
                  }
                  this.AWBtrackData.finaldestinationName = '';
                  if (this.AWBtrackData.finaldestinationid && hubDetails[this.AWBtrackData.finaldestinationid]) {
                    this.AWBtrackData.finaldestinationName = hubDetails[this.AWBtrackData.finaldestinationid];
                  }
                }
                this.showAWBTrack=true;
                this.showShipmentTrack=true;
                this.$alertify.success(result.data.ReturnMessage)
              } else {
                this.invalidTokenModal = true
                this.invalidtokenmsg = result.data.ReturnMessage
                this.showBagdetailsTable=false;
                this.invalidTokenModal = false
                this.showParentMPSDetailsTable = true;
                this.$alertify.error(result.data.ReturnMessage)
              }
            }, error => {
              console.error(error)
            })
      }
    },
    closebagShipmentDetailsModal(){
      this.showbagShipmentDetailsModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    showModalOnClickBag(bagDetails) {
      this.auditLog = bagDetails.AuditLog
      this.showModalBag = true
    },
    showParentAWBDetails() {
      this.showbagShipmentDetailsModal = true;
        },
    getBagDetails(){
      if (this.bagNo == '' || this.bagNo == undefined) {
        this.ParentAWBError = true;
        this.ParentAWBErrorMSG = 'Enter Bag No';
        return false;
      } else {
      this.ParentAWBErrorMSG = ''
      this.showPaperBagTable=false;
      this.showShipmentTrack=false;
      this.showParentMPSDetailsTable = false;
      this.showAWBTrack=false;
    //  this.showParentAWBdetailsTable = false;
      this.bagIdError=false;
      this.bagIDErrorMSG = '';
      this.isLoadingSearch = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getPaperWorkDetailsfromPaperBagNo?paperBagNo=' + this.bagNo,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.showShipmentDetailsTable=false;
            this.showBagdetailsTable=true;
            this.bagDetails = result.data.ParentBagDetails;
            this.parentAwbDetails = result.data.ParentAWBList;
            //  this.$alertify.success(result.data.ReturnMessage);

          } else {
            this.showAWBTrack=false;

            this.showShipmentDetailsTable=false;
            this.showBagdetailsTable=true;
            this.$alertify.error(result.data.ReturnMessage);
            this.bagDetails = [];
          }
        }, error => {
          console.error(error)
        })
      }
    },

    // onSubmitSearch: function() {
        //     var self = this
        //     this.$validator.validateAll().then((result) => {
        //         if (!result) {
        //             return false;
        //         }
        //         // this.$alertify.success("your message");
        //     }).catch(() => {
        //         console.log('errors exist')
        //         //this.$alertify.error("your message")
        //     });
        // },
    resetForm() {
      this.bagNo='',
      this.showBagdetailsTable=false,
      this.bagDetails='',
      this.parentAwbDetails = '',
      this.transcationDetailsForMPS='',
      this.transcationDetailsForMPSTable=false;
      this.paperWorkUFDetails=[];
      this.showPaperWorkUFModal=false;
      this.showAWBTrack=false;
      this.AWBtrackData='';
      this.chargeableWeight = 0
      this.physicalWeight = 0
      this.showShipmentTrack=false;
      this.shipmentTrackData='';
      this.paperbagdetails='';
      this.showPaperBagTable=false;
      this.ParentMPSDetails = [];
      this.isLoadingSearch = false;
      this.parentMPS = '';
      this.parentAWB = '';
      this.showParentMPSDetailsTable = true;
      this.ParentMPSError = false;
      this.ParentAWBError = false;
      this.ParentMPSErrorMSG = '';
      this.ParentAWBErrorMSG = '';
      this.closePalletizationLogModal();
      this.$validator.reset();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BagShipmentQuery/CargoShipmentBagSummary/CargoShipmentBagSummary.js